import React, { FC } from "react";
import { AppBar as MuiAppBar, AppBarProps } from "@mui/material";
import useTheme from "./useTheme";

const AppBar: FC<AppBarProps> = (props) => {
    const theme = useTheme();
    return <MuiAppBar {...props} style={{ background: theme.palette.secondary.main, ...props.style }}/>
}

export default AppBar;